<template>
  <div class="create-team">
    <div class="common-account-select-item">
      <input type="checkbox" :value="contact" v-model="localCheckList">
      <account-avatar :account="contact" />
      <div class="contact-item-name">{{ contact.im_name }}</div>
    </div>
  </div>
</template>

<script>
import AccountAvatar from '../AccountAvatar.vue';
export default {
  name: 'AccountSelectItem',
  components: {
    AccountAvatar
  },
  props: {
    contact: {
      type: Object,
      default: () => {
        return {}
      }
    },
    checkList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
    }
  },
  computed: {
    localCheckList: {
      get () {
        return this.checkList
      },
      set (value) {
        this.$emit('update:checkList', value)
      }
    }
  },
  watch: {
  },
  methods: {
  }
}
</script>

<style lang="stylus" scoped>
  .common-account-select-item {
    display: flex;
    align-items: center;
    position: relative;
    padding: 5px;
    gap: 5px;
  }
  .contact-item-name {
    margin: 0 6px 0 5px;
  }
</style>



// WEBPACK FOOTER //
// src/common/im/team/AccountSelectItem.vue